import { Reducer } from "redux";
import {
    SET_TOAST_MESSAGE,
    SHOW_TOAST_MESSAGE,
    HIDE_TOAST_MESSAGE,
    TOGGLE_TOAST_LOADING,
} from "../actions/toastActions";

export interface ToastState {
    showMessage: boolean;
    text: string;
    success: boolean;
    loading: boolean;
}

const initialState: ToastState = {
    showMessage: false,
    text: "",
    success: false,
    loading: false,
};

export const toastReducer: Reducer<ToastState> = (
    state: ToastState = initialState,
    action: any
): ToastState => {
    switch (action.type) {
        case SET_TOAST_MESSAGE:
            let text = action.text as string;
            if (text.length > 150) text = text.substring(0, text.lastIndexOf(" ", 150)) + "...";
            return { ...state, text: text, success: action.success };
        case SHOW_TOAST_MESSAGE:
            return { ...state, showMessage: true };
        case HIDE_TOAST_MESSAGE:
            return { ...state, showMessage: false };
        case TOGGLE_TOAST_LOADING:
            return { ...state, loading: action.opt };
        default:
            return state;
    }
};
